module.exports = __webpack_public_path__ + "media/video1.a1b77afc.mp4";